import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.7",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M3 18V9.5A1.5 1.5 0 0 1 4.5 8H14a2 2 0 0 1 2 2v8" }, null, -1),
    _createElementVNode("path", { d: "M3 14h18m-5-4h2.5a2.5 2.5 0 0 1 2.5 2.5V18M7 12V8M18 4.5a2.5 2.5 0 1 0 0 5" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "clinic-feature-stationary-24"}) } }